import { render, staticRenderFns } from "./CanceledArticles.vue?vue&type=template&id=c82289a2&scoped=true&"
import script from "./CanceledArticles.vue?vue&type=script&lang=js&"
export * from "./CanceledArticles.vue?vue&type=script&lang=js&"
import style0 from "./CanceledArticles.vue?vue&type=style&index=0&id=c82289a2&prod&lang=css&"
import style1 from "./CanceledArticles.vue?vue&type=style&index=1&id=c82289a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82289a2",
  null
  
)

export default component.exports